export default "__VITE_ASSET__DKyk9Lsd__"